import RegistrationPanel from "../../components/registration-panel/registration-panel.component";

export default function RegistrationPage(){
    return <RegistrationPanel/>
}